<template>
  <div class="edit-participant-button d-flex justify-content-end">
    <button
      class="button-primary primary-normal small action-button col-12 col-md-10"
      @click="openPanel"
    >
      {{ t('travellers.modifyInformation') }}
    </button>
  </div>
</template>

<script lang="ts" setup>


  // Store
  import { useStore } from '@/store'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  const store = useStore()

  // Methods
  const openPanel = (): void => {
    store.commit('modal/open', ModalId.TRAVELLER_PANEL)
  }
</script>
